import PageLink from 'Components/PageLink'

import { SVGTick } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from './Stepper.scss'
import CheckoutHelper from 'Utils/helpers/checkoutHelper'
import { connect } from 'react-redux'
import { CheckoutStage } from 'Utils/helpers/constants'
import { CartFragment } from 'Utils/api/gql/types';

type PropType = {
  stage: CheckoutStage
  cart: CartFragment | null
  deliveryAddress: Redux.IDeliveryAddress | undefined
  session: Redux.IStoreSessionData
}

const NoLink: React.SFC<{ [name: string]: any }> = (props) => {
  const { toPage, ...otherProps } = props
  return <a {...otherProps}>{props.children}</a>
}

const Stepper: React.SFC<PropType> = (props) => {
  const { stage, session, deliveryAddress, cart } = props

  const steps = CheckoutHelper.getCheckoutSteps(deliveryAddress, session.loggedIn, cart)

  return (
    <nav
      className={cl.checkoutStepper}
      role="navigation"
      aria-label="Megrendelés lépései"
    >
      <ol className={`${cg.gridX} ${steps.length === 3 ? cl.thirdStep : ''}`}>
        {steps.map((item, i) => {
          const LinkComponent = item.stage > stage ? NoLink : PageLink
          return (
          <li
            key={`step-${item.id}`}
            className={cn(
              cg.cell,
              i === 0 || i + 1 === steps.length   ? cl.small     : cl.large,
              i > 0 && i < steps.length           ? cg.textCenter : {},
              i + 1 === steps.length              ? cg.textRight  : {}
            )}
          >
            <LinkComponent
              toPage={item.stage > stage ? '' : item.href}
              className={cn(
                cl.checkoutStepper__link,
                i === 0                 ? cl.checkoutStepper__linkIsFirst     : {},
                i === steps.length - 1  ? cl.checkoutStepper__linkIsLast      : {},
                item.stage > stage      ? cl.checkoutStepper__linkIsDisabled  : {}
              )}
              title={item.ariaLabel}
              aria-disabled={item.stage > stage ? true : false}
            >
              <span className={cl.checkoutStepper__linkInnerContainer}>
                <span className={cn(cg.showForLarge, cl.checkoutStepper__linkInnerLabel)} aria-hidden={true}>
                  {stage > item.stage && (
                    <SVGTick width={20} height={20} />
                  )}
                </span>
              </span>
              <span className={cn(cl.label)}>
                {item.ariaLabel}
              </span>
            </LinkComponent>
          </li>
        )})}
      </ol>
    </nav>
  )
}

export default connect(({ deliveryAddress, session, cart }: Redux.IReduxState) => ({
  deliveryAddress,
  session,
  cart
}))(Stepper)
